import {
    ADD_CAR_TO_BATCH,
    REMOVE_CAR_FROM_BATCH,
    DISABLE_CARS_FROM_BATCH,
    ENABLE_CARS_FROM_BATCH,
    RESET_BATCH,
    CLEAR_ERRORS,
} from '../actions/types';

import Traductor from '../../components/Traductor';

const initialBatchState = {
    cars: [],
    error: '',
};

const carsLoot = (state = initialBatchState, { payload, type }) => {
    switch (type) {
        case ADD_CAR_TO_BATCH:
            //validate that all car end dates are equal
            const checkTrolleyCarsDates = state.cars.every(
                car =>
                    car.PublicationEndDate ===
                    payload.vehicle.PublicationEndDate
            );
            const checkSelectedBatchCars = payload?.history?.location?.state
                ?.selectedBatchToAdd
                ? payload.history.location.state.selectedBatchToAdd.details
                      .EndDate === payload.vehicle.PublicationEndDate
                : true;

            if (!checkTrolleyCarsDates || !checkSelectedBatchCars) {
                const t = new Traductor();
                return { ...state, error: t.getTraduction('BatchDatesError') };
            }
            return {
                ...state,
                cars: [...state.cars, payload.vehicle],
            };
        case REMOVE_CAR_FROM_BATCH:
            return {
                ...state,
                cars: state.cars.filter(car => car.Id !== payload),
            };
        case DISABLE_CARS_FROM_BATCH:
            //Id received in payload is IdPublish // WebSalesId not the vehicle Id
            return {
                ...state,
                cars: state.cars.map(car =>
                    payload.includes(+car.WebSalesId)
                        ? {
                              ...car,
                              IsBlocked: true, //Blocked to true to disable car with selector
                          }
                        : car
                ),
            };
        case ENABLE_CARS_FROM_BATCH:
            //Id received in payload is IdPublish // WebSalesId not the vehicle Id
            return {
                ...state,
                cars: state.cars.map(car =>
                    payload.cars.includes(+car.WebSalesId)
                        ? {
                              ...car,
                              IsBlocked: false, //Blocked to false to enable car with selector
                          }
                        : car
                ),
            };
        case CLEAR_ERRORS:
            return { ...state, error: '' };
        case RESET_BATCH:
            return { ...initialBatchState, enable: state.enable };
        default:
            return state;
    }
};

export default carsLoot;
